import { Routes, Route } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import OurStoryPage from '../pages/OurStoryPage';
import EiraPage from '../pages/EiraPage';
import ElmoraPage from '../pages/ElmoraPage';
import CareersPage from '../pages/CareersPage';
import MediaCentrePage from '../pages/MediaCentrePage';
import PressReleasePage from '../pages/PressReleasePage';
import NewsPage from '../pages/NewsPage';

const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/our-story" element={<OurStoryPage />} />
      <Route path="/projects/eira" element={<EiraPage />} />
      <Route path="/projects/elmora" element={<ElmoraPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/press-release" element={<PressReleasePage />} />
      <Route path="/media-centre" element={<MediaCentrePage />} />
    </Routes>
  );
};

export default UserRoutes;
